class Booking {
  constructor(container) {
    this.container = container;
    this.baseURL = container.dataset.url;

    this.toggle = container.querySelector('.visitors-toggle');
    this.submit = container.querySelector('.submit-button');
    this.number = container.querySelector('.number-fields');

    this.input = {
      datein: container.querySelector('input[name="datein"]'),
      dateout: container.querySelector('input[name="dateout"]'),
      adults: container.querySelector('input[name="adults"]'),
      children: container.querySelector('input[name="children"]'),
    };

    this.value = {
      datein: this.formatDateForValue(this.input.datein.value),
      dateout: this.formatDateForValue(this.input.dateout.value),
      adults: this.input.adults.value,
      children: this.input.children.value,
    };

    this.handleInput();
  }

  handleInput() {
    this.input.datein.addEventListener('change', (e) => {
      this.value.datein = this.formatDateForValue(e.target.value);
      if (e.target.value > this.input.dateout.value) {
        this.updateDate('dateout', e.target.value, 1);
      }
    });

    this.input.dateout.addEventListener('change', (e) => {
      this.value.dateout = this.formatDateForValue(e.target.value);
      if (e.target.value < this.input.datein.value) {
        this.updateDate('datein', e.target.value, -1);
      }
    });

    this.input.adults.addEventListener('change', (e) => {
      this.value.adults = e.target.value;
      this.updateToggleText();
    });

    this.input.children.addEventListener('change', (e) => {
      this.value.children = e.target.value;
      this.updateToggleText();
    });

    this.toggle.addEventListener('click', () => {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';

      this.toggle.setAttribute('aria-expanded', !expanded);
      this.number.setAttribute('aria-expanded', !expanded);
      // this.container.setAttribute('aria-expanded', !expanded);
    });

    this.submit.addEventListener('click', () => {
      let link = `${this.baseURL}?`;
      link += `&adults=${this.value.adults}`;
      link += `&children=${this.value.children}`;
      link += `&datein=${this.value.datein}`;
      link += `&dateout=${this.value.dateout}`;

      window.open(link, '_blank');
    });
  }

  updateToggleText() {
    const a = this.value.adults;
    const c = this.value.children;

    let str = '';

    if (a > 0) {
      str += `${a} Adult`;

      if (a > 1) str += 's';

      if (c > 0) str += ', ';
    }

    if (c > 0) {
      str += `${c} Child`;

      if (c > 1) str += 'ren';
    }

    this.toggle.querySelector('.number').innerText = str;
  }

  updateDate(param, value, adjustment) {
    const nv = new Date(value);
    nv.setDate(nv.getDate() + adjustment);

    const inputDate = this.formatDateForInput(nv);
    const valueDate = this.formatDateForValue(inputDate);

    this.input[param].value = inputDate;
    this.value[param] = valueDate;
  }

  formatDateForValue(dateStr) {
    const [y, m, d] = dateStr.split('-');
    return `${m}/${d}/${y}`;
  }

  formatDateForInput(dateObj) {
    return dateObj.toISOString().split('T')[0];
  }
}

export { Booking };
